module.exports = __webpack_public_path__ + "img/biaoqian_gongyuan.2ead46c0.png";